import React, { useState } from "react";
import ReactCrop from "react-image-crop";
import LoadingLogoPage from "../loadingPage/loadingPage";

const ZoomableImage = ({ src, crop, setCrop, scale, setScale }) => {
  const handleZoomIn = () => {
    setScale(scale + 0.1);
  };

  const handleZoomOut = () => {
    setScale(scale - 0.1);
  };

  return (
    <div>
      <ReactCrop crop={crop} onChange={(c) => setCrop(c)} aspect={1}>
        <div
          style={{
            overflow: "hidden",
            width: "375px",
            height: "250px",
            border: "3px  solid #E1E1E1",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {src ? (
            <img
              src={src}
              alt="Zoomable Image"
              style={{
                transform: `scale(${scale})`,
                transition: "transform 0.2s ease-in-out",
                userSelect: "none",
                display: "inline-block",
              }}
              draggable="true"
            />
          ) : (
            <div className="content-wrapper" style={{ background: "white" }}>
              <section
                className="content"
                style={{
                  top: "50%",
                  left: "50%",
                  backgroundColor: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <LoadingLogoPage />
              </section>
            </div>
          )}
        </div>
      </ReactCrop>
    </div>
  );
};

export default ZoomableImage;
